import axios from 'axios';
// import store from './store/store.js';
// import baseMethod from './global/baseMethod.js';
import { Message } from 'view-design';
// import Vue from 'vue'
axios.defaults.timeout = 10000;
axios.defaults.baseURL = '/api_address/'
const SUCCESS_CODE = 10000
const NOLOGIN = 20001
const FORCED_OFF = 20009
    // const msgRelay = 2000
let timer = null;
let prevUrl = "";
let cancel;
axios.interceptors.request.use(
    config => {

        if (timer == null) {
            prevUrl = config.url
            timer = setTimeout(() => {
                timer = null
                prevUrl = ""
            }, 1000)
        } else if (config.url === prevUrl) {
            if (typeof(cancel) === 'function') {
                cancel('cancle')
            }
            clearInterval(timer)
            timer = null
            prevUrl = ""
        }
        config['cancelToken'] = new axios.CancelToken(function(c) {
            cancel = c
        })
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);
// 添加一个响应拦截器
axios.interceptors.response.use(
    response => {
        cancel = null
        let err = {};
        let data = response.data;
        // 如果是直接返回的数据，没有状态码
        if (data.code === undefined) {
            return response;
        }
        switch (data.code) {
            // 成功
            case SUCCESS_CODE:
                return response;
                // 未登录
            case NOLOGIN:
                Message.error(data.msg)
                err.message = data.msg;
                // store.commit('skb/updateLogin', false);
                return Promise.reject(err);
                // 强制下线
            case FORCED_OFF:
                Message.error(data.msg)
                err.message = data.msg;
                // store.commit('skb/updateLogin', false);
                return Promise.reject(err);
                // 其他错误
            default:
                Message.error(data.msg)
                err.message = data.msg;
                return Promise.reject(err);
        }
    },
    err => {
        cancel = null
        if (err && err.response) {
            err.message = err.response.data.msg;
        } else if (axios.isCancel(err)) {
            return Promise.reject(err)
        } else {
            err.message = "请求超时";
        }
        Message.error(err.message)
        return Promise.reject(err);
    }
);

export default axios
